import { isMagentoPlaceOrderError } from "@jti/commerce";
import type { ApiMagentoPlaceOrderError } from "@jti/magento-types";

export const getPlaceOrderError = (error: unknown): ApiMagentoPlaceOrderError | undefined => {
  if (!Array.isArray(error)) {
    return undefined;
  }

  const firstError = error[0];

  if (!isMagentoPlaceOrderError(firstError)) {
    return undefined;
  }

  return firstError;
};
